import {useDispatch as useUpDispatch, useSelector as useUpSelector} from 'react-redux';
import {createStore} from 'redux';

/** @typedef {{
 *   pageOverlayed: boolean,
 *   navOpen: boolean,
 * }} State */

 /** @typedef {{type: "overlayPage"} |
  *   {type: "deOverlayPage"} |
  *   {type: "openNav"} |
  *   {type: "closeNav"}
  * } Action */

/** @type {import("redux").Store<State, Action>} */
export const store = createStore(
	(
		/** @type {State} */
		state = {
			pageOverlayed: false,
			navOpen: false,
		},
		/** @type {Action} */
		action,
	) => {
		switch (action.type) {
			case 'overlayPage':
				return {
					...state,
					pageOverlayed: true,
				};

			case 'deOverlayPage':
				return {
					...state,
					pageOverlayed: false,
				};

			case 'openNav':
				return {
					...state,
					navOpen: true,
					pageOverlayed: true,
				};

			case 'closeNav':
				return {
					...state,
					navOpen: false,
					pageOverlayed: false,
				};

			default:
				return state;
		}
	},
	// @ts-ignore
	typeof window !== 'undefined'
		// @ts-ignore
		// eslint-disable-next-line piggyback/no-restricted-global-extend
		&& window.__REDUX_DEVTOOLS_EXTENSION__
		// @ts-ignore
		// eslint-disable-next-line piggyback/no-restricted-global-extend
		&& window.__REDUX_DEVTOOLS_EXTENSION__(),
);


/** @type {import("react-redux").TypedUseSelectorHook<State>} */
export const useSelector = useUpSelector;

/** @type {() => typeof store.dispatch} */
export const useDispatch = useUpDispatch;
